<template>
  <div :class="columnClassName + (isModal ? ' in-modal' : '')">
    <column-header v-if="!isModal" :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <lock-info v-if="locked" :locked="locked" :lockStatus="lockStatus" v-on:forceLock="getComponentLock(true)" />
      <div class="row">
        <div class="col-sm-6 leftcol">
          <h3>{{ _('General') }}</h3>
          <div class="form-group">
            <label for="title">{{ _('Title') }}</label>
            <input type="text" class="form-control" id="tagTitle" v-model="tag.title" :placeholder="_('Enter tag')" />
          </div>
          <div class="form-group">
            <label for="type">{{ _('Type') }}</label>
            <select class="form-control" id="type" v-model="tag.category" disabled="disabled">
              <option value="product">{{ _('Product') }}</option>
              <option value="category">{{ _('Category') }}</option>
              <option value="admin">{{ _('Admin') }}</option>
              <option value="seo">{{ _('SEO') }}</option>
              <option value="delivery">{{ _('Delivery method') }}</option>
              <option value="order">{{ _('Order') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="locale">{{ _('Language') }}</label>
            <select class="form-control" id="locale" v-model="tag.locale">
              <option value="default">{{ _('All language versions') }}</option>
              <option v-for="locale in locales" :value="locale">{{ localeName(locale) }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-6 rightcol">
          <div class="list-group" v-if="tag.sharedProduct">
            <h3>{{ _('Products') }}</h3>
            <a v-for="prod in tag.sharedProduct.filter(p => !parseInt(p.deleted))" class="list-group-item prodLink" href="javascript:;">{{ prod.name }}</a>
            <p v-if="tag.sharedProduct.length === 0">{{ _('This tag is not connected to any products.') }}</p>
          </div>
          <div class="list-group" v-if="tag.sharedCategory">
            <h3>{{ _('Categories') }}</h3>
            <a v-for="cat in tag.sharedCategory.filter(c => !parseInt(c.deleted))" class="list-group-item catLink" href="javascript:;">{{ cat.name }}</a>
            <p v-if="tag.sharedCategory.length === 0">{{ _('This tag is not connected to any categories.') }}</p>
          </div>
          <div class="list-group" v-if="tag.sharedDeliverymethod">
            <h3>{{ _('Delivery methods') }}</h3>
            <a v-for="del in tag.sharedDeliverymethod" class="list-group-item delLink" href="javascript:;">{{ del.name }}</a>
            <p v-if="tag.sharedDeliverymethod.length === 0">{{ _('This tag is not connected to any delivery methods.') }}</p>
          </div>
        </div>
      </div>
    </div>
    <nav class="save-bar">
      <div class="flex-row space-between">
        <button class="btn btn-danger" v-on:click="remove" type="button" :disabled="!isRemoveButtonEnabled"><i class="fa fa-fw fa-trash"></i> {{ _('Delete') }}</button>
        <div class="flex-row">
          <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'

export default {
  data () {
    return {
      tag: {},
    }
  },
  mixins: [components, settingshelpers],
  methods: {
    localeName (localeStr) {
      switch (localeStr) {
        case 'fi_FI':
          return 'suomeksi'
        case 'en_US':
          return 'in English'
        case 'ru_RU':
          return 'по-русски'
        case 'sv_SE':
          return 'på svenska'
        case 'de_DE':
          return 'auf Deutsch'
        case 'it_IT':
          return 'in italiano'
        case 'fr_FR':
          return 'en français'
        case 'es_ES':
          return 'en español'
        case 'nb_NO':
          return 'på norsk'
      }
      return ''
    },
    getSaveData () {
      const exportFields = [
        'id',
        'title',
        'category',
        'locale',
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.tag[e], a), {})
      return data
    },
    async doRemove () {
      let response
      try {
        this.deleted = true
        response = await axios.delete(this.baseDomain + this.shopId + '/tags/' + this.tag.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.deleted = false
        return this.showError(this._('Deletion failed!'))
      }
      this.close()
    },
    async save () {
      this.saving = true
      const params = this.getSaveData()
      const data = {
        id: params.id,
        title: params.category + ':::' + (params.locale && params.locale !== 'default' ? params.locale + ':::' : '') + params.title
      }
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/tags/' + data.id + '.json?apikey=' + this.apiKey, data)
        } else {
          delete data.id
          response = await axios.post(this.baseDomain + this.shopId + '/tags.json?apikey=' + this.apiKey, data)
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      if (response && response.data && response.data.id) {
        await this.loadTag(response.data.id)
      }
      this.saving = false
      this.saved = true
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.resource)
      if (this.saveShouldClose) {
        this.close()
      }
    },
    loadTag (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/tags/' + id + '.json?links=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.tag = response.data
        this.storeState()
        this.loading = false
        resolve(this.tag)
      })
    }
  },
  computed: {
    saveShouldClose () {
      return this.isModal
    },
    isSaveButtonEnabled () {
      return !this.saving && !this.saved && !this.loading && !this.locked && this.tag.title
    },
    isRemoveButtonEnabled () {
      return !this.saving && !this.saved && !this.loading && !this.locked
    },
    locales() {
      return this.settings && this.settings.storefrontversions ? this.settings.storefrontversions.split(';') : []
    }
  },
  created () {
    if (this.component && this.component.initData) {
      this.loadTag(this.component.initData.tagId)
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['tagUpdate'] = async (message) => {
        if (message && message.data && this.tag && parseInt(message.data.id, 10) === parseInt(this.tag.id, 10)) {
          if (!this.unsavedChanges) { // Only update if we haven't made any changes
            this.loadTag(message.data.id)
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (this.tag && this.tag.id && parseInt(this.tag.id, 10) !== parseInt(this.component.initData.tagId, 10)) {
        try {
          await this.loadTag(this.component.initData.tagId)
        } catch(e) {}
      }
    }
  }
}
</script>